import { IcoArrowRight } from "assets/icons";
import { TravelListingProps } from "./types";

import styles from "./styles.module.scss";

export default function TravelListing({
	createdAt,
	arrival,
	departure,
	date,
	passengers,
	status,
	onClick
}: TravelListingProps) {
	let statusClass = "";
	if (status === "Pagamento pendente") {
		statusClass = styles.pending;
	} else if (status === "Nova viagem") {
		statusClass = styles.new;
	} else if (status === "Finalizada") {
		statusClass = styles.completed;
	} else if (status === "Cancelada") {
		statusClass = styles.canceled;
	}
	return (
		<div
			className={`${styles.travelListingItem} ${statusClass}`}
			onClick={onClick}
		>
			<div className={styles.container}>
				<div className={styles.content}>
					<div className={styles.travelInfo}>
						<div className={styles.travelDetails}>
							<span>
								{departure} / {arrival}
							</span>
							<span className={styles.travelPassengers}>{passengers}</span>
							<span className={`${styles.travelStatus} ${statusClass}`}>
								{status}
							</span>
						</div>
						<div className={styles.travelDate}>
							<span>{createdAt}</span>
						</div>
					</div>
					<IcoArrowRight />
				</div>
			</div>
		</div>
	);
}
